import React from "react";
import { AnimatePresence, motion } from "framer-motion";

export function FancySelect({
  value,
  onChange,
  options,
  disabled = false,
  bgSrc = "/rect.png",
}) {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef(null);

  React.useEffect(() => {
    const onDown = (e) => {
      if (!rootRef.current) return;
      if (!rootRef.current.contains(e.target)) setOpen(false);
    };
    window.addEventListener("pointerdown", onDown);
    return () => window.removeEventListener("pointerdown", onDown);
  }, []);

  const selected = options.find((o) => o.value === value) || options[0];

  return (
    <div ref={rootRef} style={{ position: "relative", display: "inline-block" }}>
      <button
  type="button"
  className="fs-btn"
  onClick={() => !disabled && setOpen((s) => !s)}
  aria-haspopup="listbox"
  aria-expanded={open}
  disabled={disabled}
  style={{
    backgroundImage: "url('/rect.png')",
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "transparent",
    border: "none",
  }}
>

        <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {selected?.label ?? ""}
        </span>
        <img
  src="/whitearrow.png"
  alt=""
  className={`fs-arrow ${open ? "is-open" : ""}`}
/>

      </button>

      <AnimatePresence>
        {open && !disabled && (
          <motion.div
            initial={{ opacity: 0, y: -6, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -6, scale: 0.98 }}
            transition={{ duration: 0.14, ease: "easeOut" }}
            style={{
              position: "absolute",
              top: "calc(100% + 6px)",
              left: 0,
              right: 0,
              zIndex: 9999,
              background: "rgba(0,0,0,0.9)",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 10,
              overflow: "hidden",
              boxShadow: "0 14px 30px rgba(0,0,0,0.55)",
            }}
          >
            {options.map((opt) => {
              const active = opt.value === value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => {
                    onChange(opt.value);
                    setOpen(false);
                  }}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    padding: "10px 12px",
                    border: "none",
                    background: active ? "rgba(255,255,255,0.12)" : "transparent",
                    color: active ? "#ffdf5f" : "#fff",
                    fontWeight: 800,
                    cursor: "pointer",
                  }}
                >
                  {opt.label}
                </button>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
